var React = require('react');

function Code (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"16 18 22 12 16 6","key":0}),React.createElement("polyline",{"points":"8 6 2 12 8 18","key":1})]);
}

Code.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-code"};

module.exports = Code;

Code.default = Code;
